var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.109375C3.98633 0.109375 0.734375 3.39062 0.734375 7.375C0.734375 11.3887 3.98633 14.6406 8 14.6406C11.9844 14.6406 15.2656 11.3887 15.2656 7.375C15.2656 3.39062 11.9844 0.109375 8 0.109375ZM11.8086 3.56641C13.7129 5.5 13.8594 8.42969 12.3945 10.4805L4.89453 2.98047C6.94531 1.51562 9.875 1.66211 11.8086 3.56641ZM4.16211 11.2129C2.25781 9.2793 2.11133 6.34961 3.57617 4.29883L11.0762 11.7988C9.02539 13.2637 6.0957 13.1172 4.16211 11.2129Z",
    fill: "#1F4760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.7155e0db83fe05da0a1ad90cf4146b53.svg";
export { ForwardRef as ReactComponent };